<template>
  <div class="group-conversation-wrap">
    <MsgList
      ref="msgList"
      class="msg-list"
      :messages="messages"
      @load-more-messages="handleLoadMoreMessages"
      @resendMessage="resendMessage"
    />
    <ChatInput
      ref="chatInput"
      :input="input"
      :readonly="readonly"
      @send="handleSend"
      @input-change="handleInputChange"
      :userInfo="userInfo"
      :groupSessionId="groupSessionId"
      :initSelectedMember="selectedMember"
      @select-member="handleSelectMember"
      @only-show-teacher="handleOnlyShowTeacher"
      @forbid-click="handleForbidClick"
    >
    </ChatInput>
  </div>
</template>
<script>
import MsgList from "../conversation/MsgList.vue";
import ChatInput from "../conversation/ChatInput.vue";
export default {
  name: "Group",
  props: {
    messages: Array,
    input: String,
    readonly: Boolean,
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    groupSessionId: {
      type: String,
      default: "",
    },
    selectedMember: {
      type: [Object, String],
      default: "all",
    },
  },
  components: {
    MsgList,
    ChatInput,
  },
  computed: {},
  methods: {
    resendMessage(message) {
      this.$emit("resendMessage", message);
    },
    handleForbidClick(callback) {
      this.$emit("forbid-click", callback);
    },
    handleOnlyShowTeacher(callback) {
      this.$emit("only-show-teacher", callback);
    },
    // 透传send事件
    handleSend(data) {
      if (this.$refs.msgList) {
        this.$refs.msgList.scrollToBottom();
      }
      this.$emit("send", data);
    },
    // 透传input-change事件
    handleInputChange(value) {
      this.$emit("input-change", value);
    },
    handleSelectMember(member) {
      this.$emit("select-member", member);
    },
    // 处理加载更多消息
    handleLoadMoreMessages(params, callback) {
      this.$emit("load-more-messages", params, callback);
    },
  },
};
</script>
<style lang="scss" scoped>
.group-conversation-wrap {
  display: flex;
  flex-direction: column;
  .msg-list {
    flex: 1;
    height: 0;
    overflow: auto;
  }
}
.chat-messages {
  /* 原样式可直接迁移 */
}
.chat-message {
  /* 如有样式一并迁移 */
}
.chat-input-area {
  /* 如有样式一并迁移 */
}
</style>
